module.exports = __webpack_public_path__ + "img/FR42529.47f49be0.svg";